import type { TemplateType } from '../../../types/ai-analysis-types';

export const DEFAULT_VARIABLES: Record<TemplateType, object> = {
    single_analysis: {
        user_preference: {
            main_goal: "新品推广",
            budget_range: "5000-10000",
            experience_level: "专家",
            time_expectation: "3个月",
            custom_requirements: "无"
        },
        product_info_section: "产品名称: 示例产品\n类目: 示例类目\n售价: $29.99",
        keyword_data: {
            keyword: "example keyword",
            search_frequency_rank: 1000,
            latest_search_frequency_rank: 950,
            rank_cagr: 5.2,
            periods_count: 12,
            total_periods: 12,
            metrics: {
                rank_score: 85,
                market_control: 45.5,
                brand_concentration: 1200,
                market_matrix_type: "竞争激烈",
                dominant_brand: "BrandA",
                market_concentration_score: 60,
                replacement_rate: 30,
                position_retention: 70,
                brand_turnover_rate: 20,
                market_stability: "稳定",
                avg_click_share: 15.5,
                click_share_cagr: 2.1,
                avg_conversion_share: 18.2,
                conversion_share_cagr: 3.5,
                traffic_quality_score: 90,
                conversion_advantage: 1.2,
                market_opportunity: 80,
                entry_barrier_score: 40,
                ad_priority_score: 85,
                ad_priority_grade: "A"
            }
        }
    },
    comparison: {
        user_preference: {
            main_goal: "利润增长",
            budget_range: "10000+",
            experience_level: "资深"
        },
        product_info_section: "产品名称: 示例产品\n核心卖点: 卖点1, 卖点2",
        keywords_summary_text: "关键词A: 排名1000, 转化率5%\n关键词B: 排名5000, 转化率8%"
    },
    recommendation: {
        user_preference: {
            main_goal: "品牌建设",
            budget_range: "20000+",
            experience_level: "专家",
            time_expectation: "6个月",
            custom_requirements: "注重长期价值"
        },
        product_info_section: "产品名称: 示例产品\n品牌理念: 创新与品质",
        keywords_summary_json: [
            { "keyword": "keyword1", "metrics": { "opportunity_score": 80 } },
            { "keyword": "keyword2", "metrics": { "opportunity_score": 60 } }
        ]
    },
    copywriting: {
        context: "产品背景信息...",
        selling_point: "核心卖点描述...",
        script_instruction: "请使用更有感染力的语气..."
    },
    product_description: {
        product_name: "示例产品名称",
        selling_points: ["卖点1: 高效便捷", "卖点2: 环保材质", "卖点3: 终身质保"]
    },
    desired_feeling: {
        product_name: "示例产品名称",
        product_description: "这是一款..."
    },
    brand_story: {
        product_name: "示例产品名称",
        brand_concept: "让生活更美好"
    },
    lifestyle_scene: {
        product_name: "示例产品名称",
        target_audience: "追求品质生活的都市白领"
    },
    target_audience: {
        product_name: "示例产品名称",
        category: "家居用品"
    },
    pain_points: {
        product_name: "示例产品名称",
        usage_scenarios: "在户外露营时..."
    },
    usage_scenarios: {
        product_name: "示例产品名称",
        product_features: "防水、便携、多功能"
    },
    primary_usp: {
        product_name: "示例产品名称",
        competitor_analysis: "竞品A价格高但功能少，竞品B质量一般..."
    },
    differentiation: {
        product_name: "示例产品名称",
        competitors: ["Competitor A", "Competitor B"]
    },
    market_positioning: {
        product_name: "示例产品名称",
        target_market: "北美高端市场"
    },
    visual_style: {
        product_name: "示例产品名称",
        brand_tone: "简约、现代、科技感"
    },
    competitor_analysis: {
        global_stats: {
            unique_asins: 100,
            unique_brands: 50,
            total_sales: 10000,
            total_revenue: 500000,
            avg_price: 29.99,
            avg_rating: 4.2,
            avg_days: 365
        },
        price_range_distribution: "$10-15: 产品数30(30%), 销量3000(30%)",
        keywords_detail: "keyword1: 结果数100, 销量1000"
    },
    rufus_analysis: {
        asin: "B08J5F3G1L",
        qa_text: "Q: Is this waterproof?\nA: Yes, it is IPX7 waterproof.\n\nQ: Does it have a warranty?\nA: It comes with a 1-year warranty."
    }
};
